import { formatDateYMD } from 'utils';

interface UseConfigFileNamingParams {
  client: string;
  lineOfBusiness: string;
  market: string;
  moduleName: string;
  customerId: string;
  lastUpdatedRaw?: string;
}

// Derives the account-scoped config file name/tooltip shared by the
// SettingsComp upload buttons (AutoOptimize, ConsumerInt, Insights, Competitive_int).
export const useConfigFileNaming = ({
  client,
  lineOfBusiness,
  market,
  moduleName,
  customerId,
  lastUpdatedRaw,
}: UseConfigFileNamingParams) => {
  const today = new Date().toISOString().split('T')[0];
  const lastUpdatedDate = formatDateYMD(lastUpdatedRaw) || today;
  const accountName = client
    ? lineOfBusiness
      ? `${client} - ${lineOfBusiness} - ${market}`
      : `${client} - ${market}`
    : null;
  const exampleFileName = accountName
    ? `${accountName}_${moduleName}_${today}.xlsx`
    : `Client - Market_${moduleName}_${today}.xlsx`;
  const uploadTooltipContent = `File name must include the exact OneSearch Account Name.\nExample: ${exampleFileName}`;
  const downloadFileName = accountName
    ? `${accountName}_${moduleName}_${lastUpdatedDate}.xlsx`
    : `${moduleName}_data_${customerId}.xlsx`;

  return {
    today,
    lastUpdatedDate,
    accountName,
    exampleFileName,
    uploadTooltipContent,
    downloadFileName,
  };
};
